import { useWhenProviderReady } from '@openfeature/react-sdk';
import { useBooleanFlag } from '@trm/feature-flags/web';

export const useNewTraderOnboardingFlag = () => ({
  isNewTraderOnboardingEnabled: useBooleanFlag('enable-new-trader-onboarding', false),
  isReady: useWhenProviderReady(),
});
